import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "./AuthProvider";
import { useSessionExpiry } from "./SessionExpiryContext";

export const StatusBasedRoute = ({ element, requiredStatus = "active" }) => {
  const { authenticated, loading, accountStatus } = useAuth();
  const { isShowingDialog } = useSessionExpiry();

  if (loading) {
    return <div></div>;
  }

  if (isShowingDialog) {
    return element;
  }

  // If not authenticated, redirect to login
  if (!authenticated) {
    return <Navigate to="/" />;
  }
  if (
    requiredStatus === "active" &&
    (accountStatus === "active" || accountStatus === "scheduledfordeletion")
  ) {
    return element;
  } else {
    return <Navigate to="/overview" />;
  }
};
